type TabProps = {
    title: string
    id?: string
    children: React.ReactNode | React.ReactNode[]
    hide?: boolean | undefined
}

const Tab = (props: TabProps) => {
    return <span>{props.children}</span>
}
export default Tab
